import { instance } from "apis/interceptor";
import { TUser as TMember } from "apis/user/index";

type ResponseType<T> = {
  success: boolean;
  message?: string;
  statusCode?: number;
  data?: T;
};

//UPDATE: (new) member(workspace) 접속
export type TUser = {
  id: string;
  email: string;
  name: string;
  autoLogin: boolean;
};

export const accessWorkspace = async (
  member: TMember
): Promise<{ success: boolean; accessToken?: string; user?: TUser; message?: string }> => {
  try {
    const res = await instance.post("/auth/member/my", member);
    return { success: true, accessToken: res.data.accessToken, user: res.data.user };
  } catch (error: any) {
    if (error.response.status && error.response.status === 404) {
      return { success: false, message: "존재하지 않는 워크스페이스입니다." };
    } else return { success: false };
  }
};

//FEAT: (new) 멤버(워크스페이스) 탈퇴
export const exitWorkspace = async (): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.delete("/auth/member/my");
    return { success: res.data.result };
  } catch (error: any) {
    if (error.response.status === 403) {
      return {
        success: false,
        statusCode: 403,
        message: "다른 멤버에게 Owner 권한을 부여한 뒤, 워크스페이스 나가기를 재시도해 주세요.",
      };
    } else return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
  }
};

//FEAT: (new) 멤버(워크스페이스) 탈퇴 가능성 확인
export const checkMemberDeletionPermission = async (): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.get("/auth/member/my/check-possible-to-delete");
    return { success: true, data: res.data.result };
  } catch (error: any) {
    return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
  }
};
